import React from 'react'
import {langTranslate} from 'helper/locale'
import { appPrefix } from 'helper/browserHelper'

const Footer = () => {
    return (
        <>
            <ul className="fs-2 ls-reset flex flex-wrap lh-copy" data-testid="footerForSA">
                <li className="c-neutral-400 fw-500 mr-4 mb-1">{langTranslate('Top Airlines:')}</li>
                <li className="mr-4 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-booking/saudi-arabian-air-airlines.html`}
                        title="Saudi Arabian Airlines"
                    >
                        {langTranslate('Saudi Airlines')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-booking/emirates-airlines.html`}
                        title="Emirates Airlines"
                    >
                        {langTranslate('Emirates')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-booking/qatar-airways-airlines.html`}
                        title="Qatar Airways"
                    >
                        {langTranslate('Qatar Airways')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-booking/flydubai-airlines.html`}
                        title="Fly dubai Airlines"
                    >
                        {langTranslate('Flydubai')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-booking/flynas-airlines.html`}
                        title="Fly Nas"
                    >
                        {langTranslate('Fly Nas')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-booking/air-arabia-airlines.html`}
                        title="Air Arabia"
                    >
                        {langTranslate('Air Arabia')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-booking/etihad-airways-airlines.html`}
                        title="Etihad Airways"
                    >
                        {langTranslate('Etihad Airways')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-booking/gulf-air-airlines.html`}
                        title="Gulf Air"
                    >
                        {langTranslate('Gulf Air')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-booking/air-india-airlines.html`}
                        title="Air India Airlines"
                    >
                        {langTranslate('Air India')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-booking/middle-east-airlines.html`}
                        title="Middle East Airlines"
                    >
                        {langTranslate('Middle East Airlines')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-booking/cebu-pacific-air-airlines.html`}
                        title="Cebu Pacific Airlines"
                    >
                        {langTranslate('Cebu Pacific Air')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-booking/turkish-airlines-airlines.html`}
                        title="Turkish Airlines"
                    >
                        {langTranslate('Turkish Airlines')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-booking/pakistan-international-airlines.html`}
                        title="Pakistan Intl Air"
                    >
                        {langTranslate('Pakistan Intl Airlines')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-booking/jet-airways-airlines.html`}
                        title="Jet Airways"
                    >
                        {langTranslate('Jet Airways')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-booking/oman-air-airlines.html`}
                        title="Oman Air"
                    >
                        {langTranslate('Oman Air')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-booking/cathay-pacific-airlines.html`}
                        title="Cathay Pacific"
                    >
                        {langTranslate('Cathay Pacific')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-booking/british-airways-airlines.html`}
                        title="British Airways"
                    >
                        {langTranslate('British Airways')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-booking/lufthansa-airlines.html`}
                        title="Lufthansa Airlines"
                    >
                        {langTranslate('Lufthansa')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-booking/kuwait-airways-airlines.html`}
                        title="Kuwait Airways"
                    >
                        {langTranslate('Kuwait Airways')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-booking/air-india-express-airlines.html`}
                        title="Air India Express"
                    >
                        {langTranslate('Air India Express')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-booking/air-asia-airlines.html`}
                        title="Air Asia"
                    >
                        {langTranslate('Air Asia')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-booking/shaheen-air-airlines.html`}
                        title="Shaheen Air"
                    >
                        {langTranslate('Shaheen Air')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-booking/indigo-airlines.html`}
                        title="Indigo Airlines"
                    >
                        {langTranslate('Indigo Airlines')}
                    </a>
                </li>
            </ul>
            <ul className="fs-2 ls-reset flex flex-wrap lh-copy">
                <li className="c-neutral-400 fw-500 mr-4 mb-1">{langTranslate('Popular Routes:')}</li>
                <li className="mr-4 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-schedule/dammam-madinah-flights.html`}
                        title="Dammam Madinah flights"
                    >
                        {langTranslate('Dammam Madinah flights')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-schedule/jeddah-bahrain-flights.html`}
                        title="Jeddah Bahrain flights"
                    >
                        {langTranslate('Jeddah Bahrain flights')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-schedule/riyadh-cairo-flights.html`}
                        title="Riyadh Cairo flights"
                    >
                        {langTranslate('Riyadh Cairo flights')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-schedule/riyadh-khartoum-flights.html`}
                        title="Riyadh Khartoum flights"
                    >
                        {langTranslate('Riyadh Khartoum flights')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-schedule/riyadh-dubai-flights.html`}
                        title="Riyadh Dubai flights"
                    >
                        {langTranslate('Riyadh Dubai flights')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-schedule/dammam-riyadh-flights.html`}
                        title="Dammam Riyadh flights"
                    >
                        {langTranslate('Dammam Riyadh flights')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-schedule/riyadh-taif-flights.html`}
                        title="Riyadh Taif flights"
                    >
                        {langTranslate('Riyadh Taif flights')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-schedule/madinah-jeddah-flights.html`}
                        title="Madinah Jeddah flights"
                    >
                        {langTranslate('Madinah Jeddah flights')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-schedule/taif-dubai-flights.html`}
                        title="Taif Dubai flights"
                    >
                        {langTranslate('Taif Dubai flights')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-schedule/madinah-bahrain-flights.html`}
                        title="Madinah Bahrain flights"
                    >
                        {langTranslate('Madinah Bahrain flights')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-schedule/jeddah-dammam-flights.html`}
                        title="Jeddah Dammam flights"
                    >
                        {langTranslate('Jeddah Dammam flights')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-schedule/jeddah-madinah-flights.html`}
                        title="Jeddah Madinah flights"
                    >
                        {langTranslate('Jeddah Madinah flights')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-schedule/dammam-kuwait-flights.html`}
                        title="Dammam Kuwait flights"
                    >
                        {langTranslate('Dammam Kuwait flights')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-schedule/madinah-riyadh-flights.html`}
                        title="Madinah Riyadh flights"
                    >
                        {langTranslate('Madinah Riyadh flights')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-schedule/jeddah-marrakech-flights.html`}
                        title="Jeddah Marrakech flights"
                    >
                        {langTranslate('Jeddah Marrakech flights')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-schedule/riyadh-jeddah-flights.html`}
                        title="Riyadh Jeddah flights"
                    >
                        {langTranslate('Riyadh Jeddah flights')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-schedule/jeddah-riyadh-flights.html`}
                        title="Jeddah Riyadh flights"
                    >
                        {langTranslate('Jeddah Riyadh flights')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-schedule/dammam-jeddah-flights.html`}
                        title="Dammam Jeddah flights"
                    >
                        {langTranslate('Dammam Jeddah flights')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-schedule/riyadh-hyderabad-flights.html`}
                        title="Riyadh Hyderabad flights"
                    >
                        {langTranslate('Riyadh Hyderabad flights')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-schedule/jeddah-dubai-flights.html`}
                        title="Jeddah Dubai flights"
                    >
                        {langTranslate('Jeddah Dubai flights')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-schedule/dammam-chennai-flights.html`}
                        title="Dammam Chennai flights"
                    >
                        {langTranslate('Dammam Chennai flights')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-schedule/riyadh-dammam-flights.html`}
                        title="Riyadh Dammam flights"
                    >
                        {langTranslate('Riyadh Dammam flights')}
                    </a>
                </li>
            </ul>
            <ul className="fs-2 ls-reset flex flex-wrap lh-copy">
                <li className="c-neutral-400 fw-500 mr-4 mb-1">{langTranslate('Other Tools:')}</li>
                <li className="mr-3 mb-1">
                    {' '}
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/hotels/saudi-arabia/`}
                        title="Hotels"
                    >
                        {langTranslate('Hotels')}
                    </a>{' '}
                </li>
                <li className="mr-3 mb-1">
                    {' '}
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-tickets/cheap-flight-air-tickets-domestic.html`}
                        title="Domestic Air Tickets"
                    >
                        {langTranslate('Domestic Air Tickets')}
                    </a>{' '}
                </li>
                <li className="mr-3 mb-1">
                    {' '}
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-schedule/flight-schedules-domestic.html`}
                        title="Domestic Flight Schedules"
                    >
                        {langTranslate('Domestic Flight Schedule')}
                    </a>{' '}
                </li>
                <li className="mr-3 mb-1">
                    {' '}
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-booking/domestic-airlines.html`}
                        title="Domestic Airlines "
                    >
                        {langTranslate('Domestic Airlines')}
                    </a>{' '}
                </li>
                <li className="mr-3 mb-1">
                    {' '}
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/tourism/airports/`}
                        title="Domestic Airports"
                    >
                        {langTranslate('Domestic Airports')}
                    </a>{' '}
                </li>
                <li className="mr-3 mb-1">
                    {' '}
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-tickets/cheap-flight-air-tickets-international.html`}
                        title="International Air Tickets"
                    >
                        {langTranslate('International Air Tickets')}
                    </a>{' '}
                </li>
                <li className="mr-3 mb-1">
                    {' '}
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-schedule/flight-schedules-international.html`}
                        title="International Flight Schedules"
                    >
                        {langTranslate('International Flight Schedule')}
                    </a>{' '}
                </li>
                <li className="mr-3 mb-1">
                    {' '}
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-booking/international-airlines.html`}
                        title="International Airlines"
                    >
                        {langTranslate('International Airlines')}
                    </a>{' '}
                </li>
                <li className="mr-3 mb-1">
                    {' '}
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/tourism/airports/international-airports.html`}
                        title="International Airports"
                    >
                        {langTranslate('International Airports')}
                    </a>{' '}
                </li>
            </ul>
        </>
    )
}

export default Footer
